/* eslint-disable react/prop-types */
import React from 'react'
import { DatePicker, Form, Input, TimePicker, Select } from 'antd'
import { includes } from 'lodash'
const FormItem = Form.Item
const { Option } = Select

const AntFieldFactory = AntComponent => ({
  field,
  form,
  hasFeedback,
  label,
  selectOptions,
  selectOptionHandler,
  submitCount,
  containerClassName,
  containerProps,
  type,
  help,
  required,
  style,
  children,
  errors,
  ...props
}) => {
  const touched = field && form.touched[field.name]
  const submitted = submitCount > 0
  const hasError = form.errors[field.name]
  const submittedError = hasError && submitted
  const touchedError = hasError && touched
  const onInputChange = ({ target: { value } }) =>
    form.setFieldValue(field.name, value)
  const onChange = value => form.setFieldValue(field.name, value)
  const onBlur = () => form.setFieldTouched(field.name, true)
  const resolveOptionValue = ({ _id = '', label }) => (
    <Option key={label}>{`${label}`}</Option>
  )

  const optionHandler = selectOptionHandler || ((name, index) => (
    typeof name === 'string' ? (
      <Option key={name}>{name}</Option>
    ) : resolveOptionValue(name)
  ))

  return (
    <FormItem
      style={style}
      className={containerClassName}
      {...containerProps}
      label={label}
      help={(touchedError || submittedError) && hasError}
      validateStatus={hasError && (touchedError || submittedError) ? 'error' : 'success'}
      required={required}
    >
      <AntComponent
        type={type}
        {...field}
        {...props}
        onBlur={onBlur}
        onChange={includes(['input', 'email', 'password', 'checkbox'], type) ? onInputChange : onChange}
      >
        {selectOptions && selectOptions.map(optionHandler)}
      </AntComponent>
    </FormItem>
  )
}

export const AntSelect = AntFieldFactory(Select)
export const AntDatePicker = AntFieldFactory(DatePicker)
export const AntDateRangePicker = AntFieldFactory(DatePicker.RangePicker)
export const AntInput = AntFieldFactory(Input)
export const AntTimePicker = AntFieldFactory(TimePicker)
